var _linearGradient, _path, _linearGradient2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Arrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ArtDYZ2lT75vkabREsTDEa",
    x1: 37,
    x2: 37,
    y1: 41.555,
    y2: 28.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#199ae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#1898de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#1691d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#1186cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#0a75bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076cb3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ArtDYZ2lT75vkabREsTDEa)",
    d: "M45.516,22.832l-3.349-3.349c-0.645-0.645-1.69-0.645-2.335,0L28,27v12.799 c0,1.065,1.287,1.598,2.04,0.845l15.476-15.476C46.161,24.523,46.161,23.477,45.516,22.832z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ArtDYZ2lT75vkabREsTDEb",
    x1: 10.443,
    x2: 34.894,
    y1: 35.985,
    y2: 11.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ArtDYZ2lT75vkabREsTDEb)",
    d: "M45.516,22.832L30.04,7.356C29.287,6.603,28,7.136,28,8.201V19H4c-1.105,0-2,0.895-2,2v6 c0,1.105,0.895,2,2,2h37c0.423,0,0.845-0.161,1.167-0.484l3.349-3.349C46.161,24.523,46.161,23.477,45.516,22.832z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Arrow);
export default __webpack_public_path__ + "static/media/icons8-arrow.19bf09832fdaa2f3ae7cce56b0d45826.svg";
export { ForwardRef as ReactComponent };